/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Assistant_Prompt_Q2Inputs */



/**
* | output |
* | --- |
* | "What should it do when something is unclear?" |
*
* @param {Uno_Field_Assistant_Prompt_Q2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_assistant_prompt_q2 = /** @type {((inputs?: Uno_Field_Assistant_Prompt_Q2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Assistant_Prompt_Q2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was soll er tun, wenn etwas unklar ist?")
	return /** @type {LocalizedString} */ ("What should it do when something is unclear?")
});